const flow = [
  { icon: 'ri-store-2-line', label: '広告主（店舗）', color: 'bg-red-100 text-red-500', desc: '商品・サービスを提供する店舗・企業' },
  { icon: 'ri-arrow-right-line', label: '', color: '', desc: '' },
  { icon: 'ri-qr-code-line', label: 'QRコード発行', color: 'bg-orange-100 text-orange-500', desc: 'STORADがトラッキングQRを自動生成' },
  { icon: 'ri-arrow-right-line', label: '', color: '', desc: '' },
  { icon: 'ri-user-smile-line', label: '来店客（消費者）', color: 'bg-yellow-100 text-yellow-600', desc: 'QRスキャン → 購入・申込' },
  { icon: 'ri-arrow-right-line', label: '', color: '', desc: '' },
  { icon: 'ri-money-dollar-circle-line', label: '成果報酬発生', color: 'bg-green-100 text-green-600', desc: '広告主・アフィリエイター双方に利益' },
];

const points = [
  { icon: 'ri-shield-check-line', title: '不正防止機能', desc: '独自の不正スキャン検知システムで健全な成果計測を実現します。' },
  { icon: 'ri-global-line', title: 'オフライン×オンライン連携', desc: '実店舗での行動をオンライン購買につなぐO2Oマーケティングを実現。' },
  { icon: 'ri-pie-chart-2-line', title: '成果分配の透明性', desc: 'ブロックチェーン技術で成果データを改ざん防止。透明性の高い報酬管理。' },
  { icon: 'ri-settings-3-line', title: 'カスタム成果設定', desc: '購入・登録・来店など多様な成果地点を自由に設定可能。' },
];

export default function AffiliateSystem() {
  return (
    <section id="affiliate" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-500 text-sm font-bold tracking-widest uppercase">Mechanism</span>
          <h2 className="text-4xl font-black text-gray-900 mt-3 mb-4">アフィリエイト仕組み</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            店舗・消費者・アフィリエイターの三者が Win-Win になるエコシステム。
          </p>
        </div>

        {/* Flow Diagram */}
        <div className="bg-gray-50 rounded-xl p-10 mb-14">
          <div className="flex flex-wrap items-center justify-center gap-4">
            {flow.map((item, i) =>
              item.label === '' ? (
                <div key={i} className="w-6 h-6 flex items-center justify-center text-gray-400">
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </div>
              ) : (
                <div key={i} className="flex flex-col items-center gap-3 w-36">
                  <div className={`w-16 h-16 flex items-center justify-center rounded-full ${item.color} text-2xl`}>
                    <i className={item.icon}></i>
                  </div>
                  <div className="text-gray-800 font-bold text-sm text-center">{item.label}</div>
                  <div className="text-gray-400 text-xs text-center leading-relaxed">{item.desc}</div>
                </div>
              )
            )}
          </div>
        </div>

        {/* Three parties explanation */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {[
            {
              role: '店舗・広告主',
              icon: 'ri-store-2-line',
              color: 'border-red-200 bg-red-50',
              iconColor: 'text-red-500',
              benefits: ['初期費用ゼロで導入可能', '成果発生時のみ費用が発生', 'QRコードデザインを自由にカスタマイズ', 'リアルタイムで効果測定'],
            },
            {
              role: 'アフィリエイター',
              icon: 'ri-megaphone-line',
              color: 'border-orange-200 bg-orange-50',
              iconColor: 'text-orange-500',
              benefits: ['店舗QRを自分のSNSでも紹介可能', '高単価案件が豊富', '専用管理画面で収益を一元管理', '月末締め翌月払い'],
            },
            {
              role: '消費者（来店客）',
              icon: 'ri-user-smile-line',
              color: 'border-green-200 bg-green-50',
              iconColor: 'text-green-600',
              benefits: ['スキャンで限定クーポン取得', 'ポイント還元サービス', 'お得な情報をすぐに受け取れる', 'プライバシー保護の安全設計'],
            },
          ].map((party, i) => (
            <div key={i} className={`rounded-xl border p-7 ${party.color}`}>
              <div className={`w-10 h-10 flex items-center justify-center mb-4 ${party.iconColor}`}>
                <i className={`${party.icon} text-2xl`}></i>
              </div>
              <h3 className="text-gray-800 font-bold text-base mb-4">{party.role}</h3>
              <ul className="flex flex-col gap-2">
                {party.benefits.map((b, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mt-0.5 flex-shrink-0"></i>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Key points */}
        <h3 className="text-gray-900 font-black text-xl mb-6 text-center">STORADの技術的な強み</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {points.map((p, i) => (
            <div key={i} className="flex gap-4 bg-gray-50 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                <i className={`${p.icon} text-red-500 text-lg`}></i>
              </div>
              <div>
                <div className="text-gray-800 font-bold text-sm mb-1">{p.title}</div>
                <div className="text-gray-500 text-sm leading-relaxed">{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
